export default __webpack_public_path__ + "static/media/food.bb65d440.png";